var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountonhold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31695",
    "data-name": "Rectangle 31695",
    width: 27.428,
    height: 27.428,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 18"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHMSURBVDhPrZPdSltREEZPaqXV+tdCiK2NiheBIk3biKCltE+g4Au0F31AQd9BvRFRLwqiVMX+SGJrNFYrxrhWOCeJyRFvMrDYO9kz39kzeyZRqVSCdtmDcG2L3Xmzr5+/JL5tbfmxDnBNwDWUU8lkeX5xoSUwVuz91LQCj6AHeqELFPsPp1CC86WV5SvWmrWIIdTJosAgjMBLGABvp9BP2IUfUETwkrVqt8TCG/XDGLyFNzAKTyES24MNWIVt+BvdsPYA1ojF1LyRQp/gI0zCaxiHHHwAzyZgCLrmZmaNrYuFxX4Cw2CwmOYzsHZiumlQOAveuucwnzejuhjm3oDnoEgKuuEheCYGPYYk6PMCrG+smGn2gXUzSKdqCqG5j/wU0Ve/qk6jWKP5Kq09c481itmQF3AMRTiHMjSKuo/8fNmTcO9/t8QMtBnto+/wG87AZ9e52v3gRwpgi+irqP/XxXLZrF/9B/uwHqKogQbIH/B8Ezy3eUuOF2ts01pYX8peewc2sC1h8U1LMZt2DXag1rRx42Qr2CLN4xSJmZop/vL3neMUWdOgi4OuRYNuLS+aBz22NXAqv8pkLPQRHIDpiCkWRtLps2ahIAiCG5wIoSSEgMd5AAAAAElFTkSuQmCC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account_on_hold",
    "data-name": "Account on hold",
    transform: "translate(-1043.518 -1334.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38833",
    "data-name": "Path 38833",
    d: "M25.4,0A25.4,25.4,0,1,1,0,25.4,25.4,25.4,0,0,1,25.4,0",
    transform: "translate(1044.122 1335.449)",
    fill: "#d31d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38834",
    "data-name": "Path 38834",
    d: "M26.256,12.586a7.278,7.278,0,1,1-7.278-7.278,7.278,7.278,0,0,1,7.278,7.278",
    transform: "translate(1050.993 1338.566)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38835",
    "data-name": "Path 38835",
    d: "M26.8,15.091a8.683,8.683,0,0,1-10.223,0c-4.333,1.936-7.787,6.266-9.39,11.75-.44,1.5.449,3.109,1.7,3.109H34.488c1.257,0,2.146-1.6,1.7-3.109-1.6-5.484-5.057-9.812-9.39-11.75",
    transform: "translate(1048.277 1344.311)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12728",
    "data-name": "Group 12728",
    transform: "translate(1058.093 1354.039)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12727",
    "data-name": "Group 12727",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12726",
    "data-name": "Group 12726",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31693",
    "data-name": "Rectangle 31693",
    width: 27.428,
    height: 27.428,
    fill: "url(#pattern)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38836",
    "data-name": "Path 38836",
    d: "M32.065,22.808a8.741,8.741,0,1,1-8.741-8.741,8.741,8.741,0,0,1,8.741,8.741",
    transform: "translate(1051.571 1342.595)",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38837",
    "data-name": "Path 38837",
    d: "M19.215,25.556a.883.883,0,0,1,.888-.932.934.934,0,0,1,0,1.865.881.881,0,0,1-.888-.932m.376-2.151-.21-7.22h1.443l-.21,7.22Z",
    transform: "translate(1054.792 1344.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31696",
    "data-name": "Rectangle 31696",
    width: 52,
    height: 52,
    transform: "translate(1043.518 1334.845)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountonhold);
export default __webpack_public_path__ + "static/media/Account on hold.4ecde7cf8bc2c8b50af8224591f1fbfc.svg";
export { ForwardRef as ReactComponent };